import { render, staticRenderFns } from "./BindingSuccessModal.vue?vue&type=template&id=42a86b9a&scoped=true"
import script from "./BindingSuccessModal.vue?vue&type=script&lang=js"
export * from "./BindingSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./BindingSuccessModal.vue?vue&type=style&index=0&id=42a86b9a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a86b9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42a86b9a')) {
      api.createRecord('42a86b9a', component.options)
    } else {
      api.reload('42a86b9a', component.options)
    }
    module.hot.accept("./BindingSuccessModal.vue?vue&type=template&id=42a86b9a&scoped=true", function () {
      api.rerender('42a86b9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/External/Shoplazza/components/BindingSuccessModal.vue"
export default component.exports